<template>
  <div class="main-wrapper-container login-page">
    <v-form ref="formLogin" class="form-container">
      <p v-if="$route.query.session === 'expired'" class="session-message" role="alert">
        Сессия истекла. Войдите в админку повторно.
      </p>
      <input-main v-for="(item, index) in infoInput"
                  :rules="item.rules"
                  @changeValue="value => setInputInfo(value.value, item.key, form)"
                  :value="form[item.key]"
                  :info-input="item"
                  :key="index"/>
      <button-main @click="submitInfo">
        {{ btnText }}
      </button-main>
    </v-form>
  </div>
</template>

<script>
import BigLogoLetter from '@/assets/logo/big-logo-letter.svg?inline'
import InputMain from "@/components/shared/input/InputMain.vue";
import ButtonMain from "@/components/shared/buttons/ButtonMain.vue";
import rulesMixin from "@/mixins/rules.mixin";
import store from "@/store";
import {api} from "@/middleware/api";
import {mapActions} from "vuex";
import {setUserAuthToken} from "@/middleware/auth";
export default {
  name: "LoginPage",
  mixins: [rulesMixin],
  components: {ButtonMain, InputMain, BigLogoLetter },
  data() {
    return {
      btnText: 'Войти',
      form: {
        email: '',
        password: ''
      }
    }
  },
  computed: {
    infoInput() {
      return [
        {
          type: 'mail',
          rules: this.rulesEmail,
          key: 'email',
          placeholder: 'Еmail',
        },
        {
          type: 'password',
          rules: this.rulesRequired,
          key: 'password',
          placeholder: 'Пароль',
        }
      ]
    },
  },
  mounted() {
    if (this.$route.query.session === 'expired') {
      this.alertError('Сессия истекла. Войдите в админку повторно.')
    }
  },
  methods: {
    ...mapActions('user', ['USER']),
    async submitInfo() {
      const {valid} = await this.$refs.formLogin.validate();
      if (valid) {
        this.IS_GLOBAL_LOADING(true);
        await api.auth.authControllerLogin(this.form).then(async r => {
          let { accessToken, user } = r.data;
          await setUserAuthToken(accessToken);
          await this.USER(user)
          this.$router.push({
            name: 'services'
          })
        }).catch(e => {
          this.alertError(e.response?.data?.message || 'Не удалось войти')
        }).finally(() => this.IS_GLOBAL_LOADING(false))
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .main-wrapper-container {
    position: relative;
    height: var(--calc-height);
    justify-content: center;
    align-items: center;
    &.login-page{
      width: 100%;
    }
    .logo-container {
      max-height: 95%;
      height: 100%;
      width: 100%;
      position: absolute;
      z-index: 0;
      left: -15%;
      top: 0;
      & svg {
        width: 100%;
        height: 100%;
      }
    }
    .form-container {
      align-items: center;
      position: relative;
      z-index: 2;
      //margin: auto 256px auto auto;
      max-width: 448px;
      display: flex;
      flex-direction: column;
      row-gap: 32px;
      width: 100%;
      @media(max-width: 1600px) {
        margin: auto;
      }
      .v-input {
        width: 100%;
      }
      .session-message {
        color: var(--color-red);
        margin: 0;
        text-align: center;
      }
    }
  }
</style>
